module.exports = __webpack_public_path__ + "static/img/exploit5.b3e8d57d.png";